/**
 * Enumeration for analytical tracker types
 */
export enum TrackerType {
  /**
   * Declares a tracker of type "Google Analytics"
   */
  GoogleAnalytics = 'GOOGLE_ANALYTICS',
  /**
   * Declares a tracker of type "HubSpot Analytics"
   */
  HubSpotAnalytics = 'HUBSPOT_ANALYTICS',

  /**
   * Declares a tracker of type "MS Clarity Analytics"
   */
  MSClarityAnalytics = 'MS_CLARITY_ANALYTICS',
}
